var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2822 15.4375V11.875C11.2822 11.7175 11.2197 11.5665 11.1083 11.4552C10.997 11.3438 10.8459 11.2813 10.6885 11.2813H8.31348C8.156 11.2813 8.00498 11.3438 7.89363 11.4552C7.78228 11.5665 7.71973 11.7175 7.71973 11.875V15.4375C7.71973 15.595 7.65717 15.746 7.54582 15.8574C7.43447 15.9687 7.28345 16.0313 7.12598 16.0313H3.56348C3.406 16.0313 3.25498 15.9687 3.14363 15.8574C3.03228 15.746 2.96973 15.595 2.96973 15.4375V8.57227C2.97106 8.4901 2.98881 8.40903 3.02195 8.33382C3.05509 8.25862 3.10295 8.19081 3.1627 8.13438L9.1002 2.73868C9.20965 2.63854 9.35263 2.58301 9.50098 2.58301C9.64933 2.58301 9.7923 2.63854 9.90176 2.73868L15.8393 8.13438C15.899 8.19081 15.9469 8.25862 15.98 8.33382C16.0131 8.40903 16.0309 8.4901 16.0322 8.57227V15.4375C16.0322 15.595 15.9697 15.746 15.8583 15.8574C15.747 15.9687 15.5959 16.0313 15.4385 16.0313H11.876C11.7185 16.0313 11.5675 15.9687 11.4561 15.8574C11.3448 15.746 11.2822 15.595 11.2822 15.4375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4afebb7416f46215fd0088f6a2fc85d2.svg";
export { ForwardRef as ReactComponent };